/* The question list on a program page (ProgramSpecPage and ProgramPage):
   one open answer at a time, button + region pairs for assistive
   technology. Styles: ProgramDetail.css (.el-faq). */
import React, { useState } from "react";

export default function ProgramFaq({ items }) {
  const [open, setOpen] = useState(-1);
  return (
    <div className="el-faq">
      {items.map((it, i) => (
        <div key={i} className={`el-faq-item${open === i ? " open" : ""}`}>
          <button
            type="button"
            id={`faq-q-${i}`}
            className="el-faq-q"
            aria-expanded={open === i}
            aria-controls={`faq-a-${i}`}
            onClick={() => setOpen((o) => (o === i ? -1 : i))}
          >
            <span>{it.q}</span>
            <span className="el-faq-icon" aria-hidden="true" />
          </button>
          <div className="el-faq-a" id={`faq-a-${i}`} role="region" aria-labelledby={`faq-q-${i}`}>
            <div className="el-faq-a-inner">{it.a}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
